<div class="modal-header">
    <h5 class="pt-4" style="padding-left:2.5rem">Editar Recibido  {{nombre}} </h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography">
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field color="accent" class="w-100">
                        <mat-label>Ingresar Cantidad</mat-label>
                        <input matInput [(ngModel)]="editRecibida" type="number">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: flex-end;" class="me-4">
    <button mat-flat-button class="bg-success text-white" type="button" (click)="guardarCantidadRecibida()">Guardar <mat-icon>save</mat-icon></button>
</mat-dialog-actions>
